/**
 *
 * @param ability
 */
export function getBaseScore(ability) {
    return ability.baseScore;
}
/**
 *
 * @param ability
 */
export function getClassBonuses(ability) {
    return ability.classBonuses;
}
/**
 *
 * @param ability
 */
export function getEntityTypeId(ability) {
    return ability.entityTypeId;
}
/**
 *
 * @param ability
 */
export function getId(ability) {
    return ability.id;
}
/**
 *
 * @param ability
 */
export function getIsMaxed(ability) {
    return ability.isMaxed;
}
/**
 *
 * @param ability
 */
export function getLabel(ability) {
    return ability.label;
}
/**
 *
 * @param ability
 */
export function getMaxStatScore(ability) {
    return ability.maxStatScore;
}
/**
 *
 * @param ability
 */
export function getMiscBonus(ability) {
    return ability.miscBonus;
}
/**
 *
 * @param ability
 */
export function getModifier(ability) {
    return ability.modifier;
}
/**
 *
 * @param ability
 */
export function getName(ability) {
    return ability.name;
}
/**
 *
 * @param ability
 */
export function getOtherBonus(ability) {
    return ability.otherBonus;
}
/**
 *
 * @param ability
 */
export function getOverrideScore(ability) {
    return ability.overrideScore;
}
/**
 *
 * @param ability
 */
export function getRacialBonus(ability) {
    return ability.racialBonus;
}
/**
 *
 * @param ability
 */
export function getScore(ability) {
    return ability.score;
}
/**
 *
 * @param ability
 */
export function getSetScore(ability) {
    return ability.setScore;
}
/**
 *
 * @param ability
 */
export function getStackingBonus(ability) {
    return ability.stackingBonus;
}
/**
 *
 * @param ability
 */
export function getStatKey(ability) {
    return ability.statKey;
}
/**
 *
 * @param ability
 */
export function getTotalScore(ability) {
    return ability.totalScore;
}
/**
 *
 * @param ability
 */
export function getProficiency(ability) {
    return ability.proficiency;
}
/**
 *
 * @param ability
 */
export function getProficiencyLevel(ability) {
    return ability.proficiencyLevel;
}
/**
 *
 * @param ability
 */
export function getIsSaveModifierModified(ability) {
    return ability.isSaveModifierModified;
}
/**
 *
 * @param ability
 */
export function getIsSaveOverridden(ability) {
    return ability.isSaveOverridden;
}
/**
 *
 * @param ability
 */
export function getIsSaveProficiencyModified(ability) {
    return ability.isSaveProficiencyModified;
}
/**
 *
 * @param ability
 */
export function getSave(ability) {
    return ability.save;
}
/**
 *
 * @param ability
 */
export function getSaveBonuses(ability) {
    return ability.saveBonuses;
}
export function getAllStatBonusSuppliers(ability) {
    return ability.allStatBonusSuppliers;
}
export function getStatSetScoreSuppliers(ability) {
    return ability.statSetScoreSuppliers;
}
export function getStatMaxBonusSuppliers(ability) {
    return ability.statMaxBonusSuppliers;
}
export function getStackingBonusSuppliers(ability) {
    return ability.stackingBonusSuppliers;
}
